import * as React from "react";
import Typography from "@mui/material/Typography";
import MappedVINsUpload from "../components/MappedVINsUpload";
import InnerPage from "../components/InnerPage";

export default function MappedVINsUploadScreen() {
  return (
    <InnerPage title="Mapped VINs Upload">
      <MappedVINsUpload />
    </InnerPage>
  );
} 